// export const getStartedLink = "/try-it-out";
export const getStartedLink = "https://fk4bvu0n5qp.typeform.com/to/vvGH3XMG"
export const calLink = "mailto:help@firecrawl.com"